"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountPlanExplorerFrequencyDropdown = void 0;
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var AngularSyncStore_1 = __importStar(require("@CommonFrontend/Utils/AngularSyncStore"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var zod_1 = require("zod");
var eligibleForEntMonthly_1 = require("../eligibleForEntMonthly");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var schema = zod_1.z.object({ isMonthly: zod_1.z.boolean(), selectedPlan: zod_1.z.object({ displayName: zod_1.z.string() }) });
var PlanExplorerUiSyncStore = (function (_super) {
    __extends(PlanExplorerUiSyncStore, _super);
    function PlanExplorerUiSyncStore(initialData, services) {
        var _this = _super.call(this, initialData, services, { extractDataFromAngular: function (planExplorerUi) { return schema.parse(planExplorerUi); } }) || this;
        _this.onAngularUpdated = function (newData) {
            _this._isMonthly = newData.isMonthly;
            _this._selectedPlan = newData.selectedPlan;
        };
        _this.onAngularUpdated(initialData);
        return _this;
    }
    Object.defineProperty(PlanExplorerUiSyncStore.prototype, "dataForAngular", {
        get: function () {
            return { isMonthly: this._isMonthly, selectedPlan: this._selectedPlan };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanExplorerUiSyncStore.prototype, "isMonthly", {
        get: function () {
            return this._isMonthly;
        },
        set: function (newValue) {
            this._isMonthly = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanExplorerUiSyncStore.prototype, "selectedPlan", {
        get: function () {
            return this._selectedPlan;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], PlanExplorerUiSyncStore.prototype, "_isMonthly", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], PlanExplorerUiSyncStore.prototype, "_selectedPlan", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function)
    ], PlanExplorerUiSyncStore.prototype, "onAngularUpdated", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], PlanExplorerUiSyncStore.prototype, "isMonthly", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PlanExplorerUiSyncStore.prototype, "selectedPlan", null);
    PlanExplorerUiSyncStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("planExplorerUi")),
        __param(1, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __metadata("design:paramtypes", [typeof (_a = typeof PlanExplorerUi !== "undefined" && PlanExplorerUi) === "function" ? _a : Object, typeof (_b = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _b : Object])
    ], PlanExplorerUiSyncStore);
    return PlanExplorerUiSyncStore;
}(AngularSyncStore_1.default));
var stringifyOption = function (option) { return "Paid ".concat(option); };
var PlanExplorerFrequencyDropdown = (0, mobx_react_1.observer)(function () {
    var _a;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var planExplorerUiSyncStore = (0, inversify_react_1.useInjection)(PlanExplorerUiSyncStore);
    var account = (0, inversify_react_1.useInjection)("account");
    var enterpriseSelected = ((_a = planExplorerUiSyncStore.selectedPlan.displayName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "enterprise";
    var usingV11Plans = usingFeature(FeatureFlag_1.default.V11PlansUpdate);
    var canToggleMonthly = !enterpriseSelected || (!usingV11Plans && (0, eligibleForEntMonthly_1.eligibleForEntMonthly)(account));
    var options = ["monthly", "yearly"];
    var isMonthly = planExplorerUiSyncStore.isMonthly;
    var selectedOption = isMonthly ? "monthly" : "yearly";
    var stringifiedSelectedOption = stringifyOption(selectedOption);
    var handleChangeOption = function (newOption) {
        planExplorerUiSyncStore.isMonthly = newOption === "monthly";
    };
    return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { size: "small", button: react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.XSmall, type: kaleidoscope_1.ButtonType.Tertiary, decorator: kaleidoscope_1.ButtonDecorator.Dropdown, disabled: !canToggleMonthly }, stringifiedSelectedOption), autoStack: true }, options.map(function (option) { return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: option, onClick: function () { return handleChangeOption(option); }, selected: selectedOption === option }, stringifyOption(option))); })));
});
var mountPlanExplorerFrequencyDropdown = function (mountReactComponent, planExplorerUi, $scope, $timeout) {
    return mountReactComponent(react_1.default.createElement(kaleidoscope_1.AngularOverlayProvider, null,
        react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container({ skipBaseClassChecks: true });
                container.bind("planExplorerUi").toConstantValue(planExplorerUi);
                container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue({ $scope: $scope, $timeout: $timeout });
                container.bind(PlanExplorerUiSyncStore).toSelf().inSingletonScope();
                return container;
            } },
            react_1.default.createElement(PlanExplorerFrequencyDropdown, null))));
};
exports.mountPlanExplorerFrequencyDropdown = mountPlanExplorerFrequencyDropdown;
